import React from 'react'

 const Loading = () => {
  return (
    <div className='loading'>
        <img src="https://i.gifer.com/2iiJ.gif" alt="" />
        <h2>Loading . . .</h2>
        {/* {https://i.gifer.com/VgI.gif} */}
    </div>
  )
}

export default Loading
